// dashboard

import UserProfile from "pages/Authentication/UserProfile";
import Login from "pages/Authentication/Login";
// import ForgetPassword from "pages/Authentication/forgetPassword";

import Logout from "pages/Authentication/LogOut";
import UserList from "pages/Customer/UserList";
import Admins from "pages/Admin";
import AdminForm from "pages/adminForm";
import blog from "pages/blog";
import BlogForm from "pages/blogForm";
import BlogAuthor from "pages/blogAuthor";
import BlogAuthorForm from "pages/blogAuthorForm";
import Media from "pages/media/mediaList";
import MediaForm from "pages/mediaForm";
import Jobs from "pages/job";
import ResetPassword from "pages/Authentication/ResetPassword";
import Leads from "pages/Lead";
import ForgetPassword from "pages/Authentication/forgetPassword";
import Page from "pages/Page";
import PageForm from "pages/pageForm";
import Category from "pages/Category";
import CategoryForm from "pages/categoryForm";
// import ResetPassword from "pages/Authentication/ResetPassword";

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Dashboard
  // { path: "/", component: Home },

  // profile

  //userlist

  { path: "/", component: Admins },
  { path: "/adminForm", component: AdminForm },
  { path: "/user-profile", component: UserProfile },
  { path: "/blog", component: blog },
  { path: "/blogForm", component: BlogForm },
  { path: "/media", component: Media },
  { path: "/mediaForm", component: MediaForm },
  { path: "/blogauthor", component: BlogAuthor },
  { path: "/blogAuthorForm", component: BlogAuthorForm },
  { path: "/page", component: Page },
  { path: "/pageForm", component: PageForm },
  { path: "/jobs", component: Jobs },
  { path: "/leads", component: Leads },
  { path: "/category", component: Category },
  { path: "/categoryForm", component: CategoryForm },
];

const publicRoutes = [
  // authentication
  { path: "/login", component: Login },
  { path: "/forget-password", component: ForgetPassword },
  { path: "/reset-password", component: ResetPassword },
  { path: "/logout", component: Logout },
];

export { authProtectedRoutes, publicRoutes };
